import React from 'react';
import I18n from '../../languages/I18n';

const Languages = props => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          gap: 8,
        }}>
        <img
          onClick={() => props.changeLanguage('fr')}
          src={require('../../assets/flag/ico-fr.png')}
          style={{
            marginLeft: 5,
            width: 50,
            opacity: props.language === 'fr' ? '1' : '0.3',
          }}
          alt="fr"
        />
        <div onClick={() => props.changeLanguage('fr')} style={{fontSize: 24, color: props.language === 'fr' ? '#FFF' : '#696969'}}>
          {I18n.t('languages_name.fr')}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          marginTop: 10,
          gap: 8,
        }}>
        <img
          onClick={() => props.changeLanguage('en')}
          src={require('../../assets/flag/ico-uk.png')}
          style={{
            marginLeft: 5,
            width: 50,
            opacity: props.language === 'en' ? '1' : '0.3',
          }}
          alt="en"
        />
        <div onClick={() => props.changeLanguage('en')} style={{fontSize: 24, color: props.language === 'en' ? '#FFF' : '#696969'}}>
          {I18n.t('languages_name.en')}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          marginTop: 10,
          gap: 8,
        }}>
        <img
          onClick={() => props.changeLanguage('es')}
          src={require('../../assets/flag/ico-es.png')}
          style={{
            marginLeft: 5,
            width: 50,
            opacity: props.language === 'es' ? '1' : '0.3',
          }}
          alt="es"
        />
        <div onClick={() => props.changeLanguage('es')} style={{fontSize: 24, color: props.language === 'es' ? '#FFF' : '#696969'}}>
          {I18n.t('languages_name.es')}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          marginTop: 10,
          gap: 8,
        }}>
        <img
          onClick={() => props.changeLanguage('eu')}
          src={require('../../assets/flag/ico-bask.png')}
          style={{
            marginLeft: 5,
            width: 50,
            opacity: props.language === 'eu' ? '1' : '0.3',
          }}
          alt="eu"
        />
        <div onClick={() => props.changeLanguage('eu')} style={{fontSize: 24, color: props.language === 'eu' ? '#FFF' : '#696969'}}>
          {I18n.t('languages_name.eu')}
        </div>
      </div>
    </>
  );
};

export default Languages;
